import React from 'react';
import { ArcPasswordInput } from '@src/core/ui';
import { IPasswordInputProps } from './types';

const PasswordInput: React.FC<IPasswordInputProps> = ({ 
  register, 
  error, 
  label = 'Password',
  autoComplete = 'off' 
}) => {
  return (
    <ArcPasswordInput
      fullWidth
      label={label}
      autoComplete={autoComplete}
      error={Boolean(error)}
      helperText={error?.message}
      {...register}
    />
  );
};

export default PasswordInput;

